import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import Header from '../components/header/Header';
import ImpersonationBar from '../components/ImpersonationBar';
import Sidebar, { DRAWER_WIDTH } from '../components/sidebar/Sidebar';

/**
 * Shell das telas logadas, igual ao do konq-backoffice: sidebar fixa à esquerda
 * (gaveta no mobile), header translúcido no topo e o conteúdo da rota no meio.
 */
export default function HomeLayout({ children }) {
  const [menuMobileAberto, setMenuMobileAberto] = useState(false);
  const larguraConteudo = { xs: '100%', md: `calc(100% - ${DRAWER_WIDTH}px)` };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Header onMenuToggle={() => setMenuMobileAberto((aberto) => !aberto)} />
      <Sidebar open={menuMobileAberto} onClose={() => setMenuMobileAberto(false)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          overflowX: 'hidden',
          width: larguraConteudo,
          ml: { md: `${DRAWER_WIDTH}px` },
          p: { xs: 1.5, sm: 2, md: 3 },
        }}
      >
        <Toolbar />
        <ImpersonationBar />
        {children}
        <Outlet />
      </Box>
    </Box>
  );
}
